// removed by extract-text-webpack-plugin
module.exports = {"headerWrapper":"app-module_headerWrapper_263qC","headerCategoriesWrapper":"app-module_headerCategoriesWrapper_1zqtN","headerCategories":"app-module_headerCategories_1YSeA","gridWide":"app-module_gridWide_2MZSC","contentSection":"app-module_contentSection_9jznX"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/app.module.css
// module id = 280
// module chunks = 1 2 3